import { createSelector } from 'reselect';

const tagsSelector = createSelector(
  (state) => state.tags,
  (tags) => tags,
);

export const isLoading = createSelector(tagsSelector, (tags) => tags.isLoading);

export const list = createSelector(tagsSelector, (tags) => tags.list);

export const error = createSelector(tagsSelector, (tags) => tags.error);

export const success = createSelector(tagsSelector, (tags) => tags.success);

export const tagsAlreadyFetched = createSelector(tagsSelector, (tags) => tags.fetched);

export default tagsSelector;
